<template>
  <div class="app-main-inner check-expression">
    <el-card class="box-card" style="height: 100%;" :body-style="{padding:'0px'}">
      <div slot="header">
        <span>{{ $t('SystemMaintenance.ValidationExpression') }}</span>
        <div v-show="isEditCheckRule">
          <template v-if="currOptStatus===optStatusDef.normal">
            <el-button type="primary" @click="showAdd">{{ $t('SystemMaintenance.Create') }}</el-button>
            <el-button type="primary" @click="showEdit">{{ $t('SystemMaintenance.Edit') }}</el-button>
            <el-button type="danger" @click="del">{{ $t('SystemMaintenance.Delete') }}</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="save">{{ $t('SystemMaintenance.Save') }}</el-button>
            <el-button type="primary" @click="cancel">{{ $t('SystemMaintenance.Cancel') }}</el-button>
          </template>
        </div>
      </div>
      <div class="app-main-inner-row" :style="{position:'relative','min-height': '300px','height':(isEdit?'auto':'100%')}">
        <div v-show="isEdit" class="pure-loading-mask" />

        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width:100%;"
        />
      </div>
      <div v-show="isEditCheckRule && currOptStatus" class="app-main-inner-row">
        <el-form style="width:100%;" label-position="left" label-width="90px">
          <el-form-item :label="$t('SystemMaintenance.Relation')">
            <el-radio-group v-model="oneCheckExpression.relation" :disabled="!isEdit">
              <el-radio :label="0">{{ $t('SystemMaintenance.And') }}</el-radio>
              <el-radio :label="1">{{ $t('SystemMaintenance.Or') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.ValidationItem')">
            <el-select v-model="oneCheckExpression.checkItem" :disabled="!isEdit" style="width:300px;" filterable @change="onCheckItemChange">
              <el-option
                v-for="(item,index) in checkItems"
                v-show="filterCheckItems(checkRule.checkNode, item.code)"
                :key="index"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Operation')">
            <el-select
              v-model="oneCheckExpression.operator"
              :disabled="!isEdit || oneCheckExpression.checkItem === 'MBL_CANNOT_REPEATED' || oneCheckExpression.checkItem === LOGIC_MANIFEST_EQUAL_CONTAINER_NUM.code || oneCheckExpression.checkItem === LOGIC_QUANTITY_WEIGHT_VOLUME_CONSISTENT.code"
              style="width:300px;"
              @change="p=>{operateChangeHandle(p)}"
            >
              <el-option
                v-for="(item,index) in operators"
                v-show="filterOperators(oneCheckExpression.checkItem, item.code)"
                :key="index"
                :label="item.chineseName"
                :value="item.code"
              />
              <el-option
                v-if="showLikeOperator"
                key="like"
                :label="LIKE_OPERATOR.chineseName"
                :value="LIKE_OPERATOR.code"
              />
              <el-option
                v-if="showNotLikeOperator"
                key="notLike"
                :label="NOT_LIKE_OPERATOR.chineseName"
                :value="NOT_LIKE_OPERATOR.code"
              />
              <el-option
                v-if="oneCheckExpression.checkItem === LOGIC_DYNAMIC_FILE_TYPE.code || oneCheckExpression.checkItem === IS_ATTACHMENT_MISSING.code || oneCheckExpression.checkItem === LOGIC_AP_CHARGE_ACCOUNT_ID_NOT_UNIQUE.code"
                key="satisfyOne"
                :label="SATISFY_ONE.chineseName"
                :value="SATISFY_ONE.code"
              />
              <el-option
                v-if="showNotEmptyOperator"
                key="notEmpty"
                :label="NOT_EMPTY.chineseName"
                :value="NOT_EMPTY.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="oneCheckExpression.operator === NOT_EMPTY.code" :label="$t('SystemMaintenance.FilterValue')">
            <el-input v-model="oneCheckExpression.checkValue" label=" " :disabled="true" style="width:300px;" />
          </el-form-item>
          <el-form-item v-else-if="oneCheckExpression.checkItem === 'TRUST_JOB_STATE' || oneCheckExpression.checkItem === 'RELATED_JOB_STATE'" :label="$t('SystemMaintenance.FilterValue')">
            <el-select v-model="oneCheckExpression.checkValue" :disabled="!isEdit" style="width:300px;">
              <el-option
                v-for="(item,index) in jobStatus"
                :key="index"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-else-if="oneCheckExpression.checkItem === 'LOCAL_SERVICES'" :label="$t('Message.FilterValue')">
            <el-select v-model="oneCheckExpression.checkValue" :disabled="!isEdit" style="width:300px;">
              <el-option
                v-for="(item,index) in LOCAL_SERVICES_TYPE"
                :key="index"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-else-if="oneCheckExpression.checkItem === 'FILE_UPLOADED'"
            :label="$t('SystemMaintenance.FilterValue')"
          >
            <el-select v-model="fileTypeEditor.lob" :disabled="!isEdit" style="width:300px;">
              <el-option :label="$t('CargoMsg.Cargo_OceanExport')" value="SE" />
              <el-option :label="$t('CargoMsg.Cargo_OceanImport')" value="SI" />
              <el-option :label="$t('CargoMsg.Cargo_AirExport')" value="AE" />
              <el-option :label="$t('CargoMsg.Cargo_AirImport')" value="AI" />
              <el-option :label="$t('CargoMsg.Cargo_RailwayBusiness')" value="RE" />
              <el-option :label="$t('CargoMsg.Cargo_IntegratedJob')" value="IE" />
            </el-select>
            <el-input :value="convertFileCategoryLabel(oneCheckExpression.checkValue)" :disabled="!isEdit" :placeholder="$t('SystemMaintenance.SelectFileType')" style="width: 300px;margin-left: 10px;" @focus="onSelectFileType" />
          </el-form-item>
          <el-form-item
            v-else-if="oneCheckExpression.checkItem === LOGIC_DYNAMIC_FILE_TYPE.code && oneCheckExpression.operator === SATISFY_ONE.code"
            :label="$t('SystemMaintenance.FilterValue')"
          >
            <el-select v-model="fileTypeEditor.lob" :disabled="!isEdit" style="width:300px;">
              <el-option :label="$t('CargoMsg.Cargo_OceanExport')" value="SE" />
              <el-option :label="$t('CargoMsg.Cargo_OceanImport')" value="SI" />
              <el-option :label="$t('CargoMsg.Cargo_AirExport')" value="AE" />
              <el-option :label="$t('CargoMsg.Cargo_AirImport')" value="AI" />
              <el-option :label="$t('CargoMsg.Cargo_RailwayExport')" value="RE" />
              <el-option :label="$t('CargoMsg.Cargo_RailwayImport')" value="RI" />
              <el-option :label="$t('CargoMsg.Cargo_Parter')" value="PT" />
              <el-option :label="$t('CargoMsg.Cargo_FbaSea')" value="FBA_SE" />
              <el-option :label="$t('CargoMsg.Cargo_FbaAir')" value="FBA_AE" />
              <el-option :label="$t('CargoMsg.Cargo_FbaRailway')" value="FBA_RE" />
              <el-option :label="$t('CargoMsg.Cargo_IntegratedJob')" value="IE" />
            </el-select>
            <el-input :value="oneCheckExpression.checkValue" :disabled="!isEdit" :placeholder="$t('SystemMaintenance.SelectFileType')" style="width: 300px;margin-left: 10px;" @focus="onSelectFileType" />
          </el-form-item>
          <el-form-item
            v-else-if="oneCheckExpression.checkItem === IS_ATTACHMENT_MISSING.code && oneCheckExpression.operator === CheckRuleConstants.EQUAL.code"
            :label="$t('SystemMaintenance.FilterValue')"
          >
            <el-select v-model="fileTypeEditor.lob" :disabled="!isEdit" style="width:300px;">
              <el-option :label="$t('CargoMsg.Cargo_Parter')" value="PT" />
            </el-select>
            <el-input :value="oneCheckExpression.checkValue" :disabled="!isEdit" :placeholder="$t('SystemMaintenance.SelectFileType')" style="width: 300px;margin-left: 10px;" @focus="onSelectFileType" />
          </el-form-item>
          <el-form-item v-else-if="oneCheckExpression.checkItem === 'SLAVE_FILE_VERIFY' || oneCheckExpression.checkItem === LOGIC_MANIFEST_EQUAL_CONTAINER_NUM.code" :label="$t('SystemMaintenance.FilterValue')">
            <el-input v-model="oneCheckExpression.checkValue" disabled style="width:300px;" />
          </el-form-item>
          <el-form-item v-else-if="oneCheckExpression.checkItem === LOGIC_SENSITIVE_WORD_ENGLISH_NAME.code" :label="$t('SystemMaintenance.FilterValue')">
            <el-select v-model="oneCheckExpression.checkValue" :disabled="!isEdit" style="width:300px;" filterable>
              <el-option v-for="(item,index) in sensitiveWordEnglishSet" :key="index" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item v-else-if="oneCheckExpression.checkItem === LOGIC_APPLICATION_STATUS_FOR_RELEASE.code" :label="$t('SystemMaintenance.FilterValue')">
            <el-select v-model="oneCheckExpression.checkValue" :disabled="!isEdit" style="width:300px;" filterable>
              <el-option :label="$t('SeaExport.NotApplying')" value="0" />
              <el-option :label="$t('SeaExport.Requested')" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item v-else-if="oneCheckExpression.checkItem === LOGIC_SENSITIVE_WORD_CHINESE_NAME.code" :label="$t('SystemMaintenance.FilterValue')">
            <el-select v-model="oneCheckExpression.checkValue" :disabled="!isEdit" style="width:300px;" filterable>
              <el-option v-for="(item,index) in sensitiveWordChinesSet" :key="index" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item v-else-if="oneCheckExpression.checkItem === LOGIC_SENSITIVE_WORD_MARK.code" :label="$t('SystemMaintenance.FilterValue')">
            <el-select v-model="oneCheckExpression.checkValue" :disabled="!isEdit" style="width:300px;" filterable>
              <el-option v-for="(item,index) in sensitiveWordMarkSet" :key="index" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item v-else-if="[LOGIC_SENSITIVE_WORD_COMMUNICATION_FIRST_LINE.code, LOGIC_SENSITIVE_WORD_HBL_COMMUNICATION_FIRST_LINE.code, LOGIC_SENSITIVE_WORD_JOB_COMMUNICATION_FIRST_LINE.code].includes(oneCheckExpression.checkItem)" :label="$t('SystemMaintenance.FilterValue')">
            <el-select v-model="oneCheckExpression.checkValue" :disabled="!isEdit" style="width:300px;" filterable>
              <el-option v-for="(item,index) in sensitiveWordCommunicationSet" :key="index" :value="item" />
            </el-select>
          </el-form-item>
          <!--应付费用结算对象不唯一-->
          <el-form-item v-else-if="oneCheckExpression.checkItem === LOGIC_AP_CHARGE_ACCOUNT_ID_NOT_UNIQUE.code" :label="$t('SystemMaintenance.FilterValue')">
            <cargo-advance-select
              key="chargeItem-multiple"
              no="chargeItem-multiple"
              style="width:300px;"
              options-width="250px"
              filterable
              :clearable="true"
              :select-type="selectTypeNames.basic_data_ChargeItem"
              :default-multiple-value="toArray(oneCheckExpression.checkValue) instanceof Array ? toArray(oneCheckExpression.checkValue) : []"
              tag-value="itemId"
              tag-name="enName"
              :multiple="true"
              @parentCallBack="p=>oneCheckExpression.checkValue=p.value"
            />
          </el-form-item>
          <el-form-item v-else-if="oneCheckExpression.checkItem === REQUIRE_USER_DEFINED_ROLE_ID1.code" :label="$t('SystemMaintenance.FilterValue')">
            <cargo-advance-select
              :disabled="!isEdit"
              :select-type="selectTypeNames.basic_data_User"
              :url="URL.sys.getUsersByPrivilegeDetail"
              :cache="false"
              :method-params="{ category: 'role', shape: 'userDefinedRole1',active:true}"
              filterable
              :default-multiple-value="toNumArray(oneCheckExpression.checkValue)"
              :multiple="true"
              style="width:300px;"
              @parentCallBack="p=>{oneCheckExpression.checkValue=toTxt(p.value)}"
            />
          </el-form-item>
          <el-form-item v-else-if="oneCheckExpression.checkItem === REQUIRE_USER_DEFINED_ROLE_ID2.code" :label="$t('SystemMaintenance.FilterValue')">
            <cargo-advance-select
              :disabled="!isEdit"
              :select-type="selectTypeNames.basic_data_User"
              :url="URL.sys.getUsersByPrivilegeDetail"
              :cache="false"
              :method-params="{ category: 'role', shape: 'userDefinedRole2',active:true }"
              filterable
              :default-multiple-value="toNumArray(oneCheckExpression.checkValue)"
              :multiple="true"
              style="width:300px;"
              @parentCallBack="p=>{oneCheckExpression.checkValue=toTxt(p.value)}"
            />
          </el-form-item>
          <el-form-item
            v-else-if="oneCheckExpression.checkItem === LOGIC_CONSIGNATION_COMPANY_SCOPE.code || oneCheckExpression.checkItem === LOGIC_RECEIVABLE_ACCOUNT_OBJECT_SCOPE.code || oneCheckExpression.checkItem === CLIENT_SCOPE_HAVE_CHARGE.code"
            :label="$t('SystemMaintenance.FilterValue')"
          >
            <cargo-advance-select
              :disabled="!isEdit"
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="oneCheckExpression.checkItem === LOGIC_CONSIGNATION_COMPANY_SCOPE.code ? { customer: true, active: true } : { active: true }"
              filterable
              :default-multiple-value="toNumArray(oneCheckExpression.checkValue)"
              :multiple="true"
              style="width:300px;"
              @parentCallBack="p=>{oneCheckExpression.checkValue=toTxt(p.value)}"
            />
          </el-form-item>
          <el-form-item v-else-if="oneCheckExpression.checkItem === BILLING_CHARGE_CONFIRM_STATE_CHECK.code" :label="$t('SystemMaintenance.FilterValue')">
            <el-select v-model="oneCheckExpression.checkValue" :disabled="!isEdit" style="width:300px;" filterable>
              <el-option :label="$t('SeaExport.yes')" value="yes" />
            </el-select>
          </el-form-item>
          <el-form-item v-else-if="oneCheckExpression.checkItem === LOGIC_INVOICE_TAX_NATURE_SAME.code" :label="$t('SystemMaintenance.FilterValue')">
            <el-select v-model="oneCheckExpression.checkValue" :disabled="!isEdit" style="width:300px;" filterable>
              <el-option :label="$t('SeaExport.yes')" value="1" />
              <el-option :label="$t('SeaExport.no')" value="0" />
            </el-select>
          </el-form-item>
          <el-form-item v-else-if="oneCheckExpression.checkItem === LOGIC_INVOICE_NATURE.code" :label="$t('Message.FilterValue')">
            <el-select v-model="oneCheckExpression.checkValue" :disabled="!isEdit" style="width:300px;">
              <el-option
                v-for="(item,index) in INVOICE_NATURES"
                :key="index"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-else :label="$t('SystemMaintenance.FilterValue')">
            <el-input v-model="oneCheckExpression.checkValue" :disabled="!isEdit || oneCheckExpression.checkItem === 'MBL_CANNOT_REPEATED' || oneCheckExpression.checkItem === LOGIC_QUANTITY_WEIGHT_VOLUME_CONSISTENT.code" style="width:300px;" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.CustomDescription')">
            <el-input v-model="oneCheckExpression.customDescription" :disabled="!isEdit" style="width:300px;" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Remarks')">
            <el-input v-model="oneCheckExpression.remark" :disabled="!isEdit" style="width:300px;" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 文件类型选择对话框 -->
    <mx-file-type-editor
      v-if="fileTypeEditor.visible"
      :visible.sync="fileTypeEditor.visible"
      :lob="fileTypeEditorLob"
      :file-id="fileTypeEditor.fileId"
      :file-category="fileTypeEditor.fileCategory"
      @saveFileType="onSaveFileType"
    />
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'
import { getCheckExpressionByUuid, getCheckExpressionList, delCheckExpression } from '@/api/sysManage/baseConfig/checkRuleConfig'
import { Assert } from '@/utils/validate'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import CommonState, { getNameByCode } from '@/class/cargo/model/parameters/CommonState'
import { LOCAL_SERVICES_TYPE } from '@/class/cargo/model/parameters/SystemConstants'
import { getUuid } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import MxFileTypeEditor from '@/components/Cargo/Job/mxFileTypeEditor'
import { getDocCategoryTypeTree } from '@/api/sysManage/baseConfig/docCategory'
import * as sensitiveWordApi from '@/api/basicData/sensitiveWord'
import { basicCacheKeys as selectTypeNames } from '@/utils/cacheConfig'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'

export default {
  name: 'CheckExpression',
  components: { CargoAdvanceSelect, MxFileTypeEditor },
  props: {
    checkRule: {
      type: Object,
      required: true
    },
    isEditCheckRule: {
      type: Boolean,
      required: true
    }
  },
  data() {
    const initOptStatusDef = { normal: 0, edit: 1 }
    return {
      loading: false,
      checkItems: [],
      operators: [],
      jobStatus: [
        new CommonState('0', '正操作', 'Operating'),
        new CommonState('11', '预提交', 'Pre Commit'),
        new CommonState('1', '已提交', 'Committed'),
        new CommonState('2', '已审核', 'Verified')
      ],
      URL,
      NODE_SAVE_PARTNER: CheckRuleConstants.NODE_SAVE_PARTNER,
      NODE_COMMIT_PARTNER: CheckRuleConstants.NODE_COMMIT_PARTNER,
      LOCAL_SERVICES_TYPE,
      LOGIC_SENSITIVE_WORD_ENGLISH_NAME: CheckRuleConstants.LOGIC_SENSITIVE_WORD_ENGLISH_NAME,
      LOGIC_APPLICATION_STATUS_FOR_RELEASE: CheckRuleConstants.LOGIC_APPLICATION_STATUS_FOR_RELEASE,
      LOGIC_SENSITIVE_WORD_CHINESE_NAME: CheckRuleConstants.LOGIC_SENSITIVE_WORD_CHINESE_NAME,
      LOGIC_SENSITIVE_WORD_MARK: CheckRuleConstants.LOGIC_SENSITIVE_WORD_MARK,
      LOGIC_SENSITIVE_WORD_COMMUNICATION_FIRST_LINE: CheckRuleConstants.LOGIC_SENSITIVE_WORD_COMMUNICATION_FIRST_LINE,
      LOGIC_SENSITIVE_WORD_HBL_COMMUNICATION_FIRST_LINE: CheckRuleConstants.LOGIC_SENSITIVE_WORD_HBL_COMMUNICATION_FIRST_LINE,
      LOGIC_SENSITIVE_WORD_JOB_COMMUNICATION_FIRST_LINE: CheckRuleConstants.LOGIC_SENSITIVE_WORD_JOB_COMMUNICATION_FIRST_LINE,
      LOGIC_MANIFEST_EQUAL_CONTAINER_NUM: CheckRuleConstants.LOGIC_MANIFEST_EQUAL_CONTAINER_NUM,
      LOGIC_DYNAMIC_FILE_TYPE: CheckRuleConstants.LOGIC_DYNAMIC_FILE_TYPE,
      IS_ATTACHMENT_MISSING: CheckRuleConstants.IS_ATTACHMENT_MISSING,
      LOGIC_QUANTITY_WEIGHT_VOLUME_CONSISTENT: CheckRuleConstants.LOGIC_QUANTITY_WEIGHT_VOLUME_CONSISTENT,
      LOGIC_AP_CHARGE_ACCOUNT_ID_NOT_UNIQUE: CheckRuleConstants.LOGIC_AP_CHARGE_ACCOUNT_ID_NOT_UNIQUE,
      LIKE_OPERATOR: CheckRuleConstants.LIKE,
      NOT_LIKE_OPERATOR: CheckRuleConstants.NOT_LIKE,
      SATISFY_ONE: CheckRuleConstants.SATISFY_ONE,
      NOT_EMPTY: CheckRuleConstants.NOT_EMPTY,
      REQUIRE_CUSTOMER_LEVEL: CheckRuleConstants.REQUIRE_CUSTOMER_LEVEL,
      REQUIRE_USER_DEFINED_ROLE_ID1: CheckRuleConstants.REQUIRE_USER_DEFINED_ROLE_ID1,
      REQUIRE_USER_DEFINED_ROLE_ID2: CheckRuleConstants.REQUIRE_USER_DEFINED_ROLE_ID2,
      BILL_TAX_ACCOUNT: CheckRuleConstants.BILL_TAX_ACCOUNT,
      BILL_COMPANY_EMAIL: CheckRuleConstants.BILL_COMPANY_EMAIL,
      REQUIRE_INVOICE_TITLE: CheckRuleConstants.REQUIRE_INVOICE_TITLE,
      REQUIRE_OPENING_BANK: CheckRuleConstants.REQUIRE_OPENING_BANK,
      REQUIRE_BANK_ACCOUNT_NUMBER: CheckRuleConstants.REQUIRE_BANK_ACCOUNT_NUMBER,
      REQUIRE_OUR_TITLE: CheckRuleConstants.REQUIRE_OUR_TITLE,
      LOGIC_CONSIGNATION_COMPANY_SCOPE: CheckRuleConstants.LOGIC_CONSIGNATION_COMPANY_SCOPE,
      CLIENT_SCOPE_HAVE_CHARGE: CheckRuleConstants.CLIENT_SCOPE_HAVE_CHARGE,
      LOGIC_RECEIVABLE_ACCOUNT_OBJECT_SCOPE: CheckRuleConstants.LOGIC_RECEIVABLE_ACCOUNT_OBJECT_SCOPE,
      SECONDARY_SERVICE_TYPE_REQUIRE: CheckRuleConstants.SECONDARY_SERVICE_TYPE_REQUIRE,
      REQUIRE_CHECKED_HBL: CheckRuleConstants.REQUIRE_CHECKED_HBL,
      LOGIC_AR_ACCOUNT_CUSTOMER_CODE: CheckRuleConstants.LOGIC_AR_ACCOUNT_CUSTOMER_CODE,
      BILLING_CHARGE_CONFIRM_STATE_CHECK: CheckRuleConstants.BILLING_CHARGE_CONFIRM_STATE_CHECK,
      LOGIC_INVOICE_NATURE: CheckRuleConstants.LOGIC_INVOICE_NATURE,
      LOGIC_INVOICE_TAX_NATURE_SAME: CheckRuleConstants.LOGIC_INVOICE_TAX_NATURE_SAME,
      INVOICE_NATURES: CheckRuleConstants.INVOICE_NATURES,
      REQUIRE_AR_CHARGE_RATE: CheckRuleConstants.REQUIRE_AR_CHARGE_RATE,
      REQUIRE_AP_CHARGE_RATE: CheckRuleConstants.REQUIRE_AP_CHARGE_RATE,
      REQUIRE_CREDIT_PAYMENT_PERIOD: CheckRuleConstants.REQUIRE_CREDIT_PAYMENT_PERIOD.code,
      REQUIRE_CREDIT_ADDITIONAL_DESCRIPTION: CheckRuleConstants.REQUIRE_CREDIT_ADDITIONAL_DESCRIPTION.code,
      REQUIRE_CONTACT_PERSON: CheckRuleConstants.REQUIRE_CONTACT_PERSON.code,
      REQUIRE_INVOICE_PAYEE: CheckRuleConstants.REQUIRE_INVOICE_PAYEE.code,
      REQUIRE_INVOICE_PAYEE_BANK: CheckRuleConstants.REQUIRE_INVOICE_PAYEE_BANK.code,
      optStatusDef: initOptStatusDef,
      currOptStatus: initOptStatusDef.normal,
      gridOptions: {},
      rowData: [],
      gridParams: {},
      gridApi: {},
      oneCheckExpression: {
        uuid: '',
        relation: 0,
        checkItem: '',
        checkRuleUuid: '',
        checkValue: '',
        operator: ''
      },
      fileTypeEditor: {
        visible: false,
        lob: 'SE',
        fileId: '',
        fileCategory: ''
      },
      docTypeMap: new Map(),
      docTypeReverseMap: new Map(),
      sensitiveWordEnglishSet: new Set(),
      sensitiveWordChinesSet: new Set(),
      sensitiveWordMarkSet: new Set(),
      sensitiveWordCommunicationSet: new Set()
    }
  },
  computed: {
    CheckRuleConstants() {
      return CheckRuleConstants
    },
    selectTypeNames() {
      return selectTypeNames
    },
    isEdit() {
      return (this.currOptStatus === this.optStatusDef.edit) && this.isEditCheckRule
    },
    columnDefs() {
      return [
        {
          headerName: this.$t('SystemMaintenance.Relation'),
          field: 'relation',
          width: 80,
          cellRenderer: (params) => {
            return params.value === 0 ? this.$t('SystemMaintenance.And') : this.$t('SystemMaintenance.Or')
          }
        }, {
          headerName: this.$t('SystemMaintenance.ValidationItem'),
          field: 'checkItem',
          width: 200,
          cellRenderer: (params) => {
            return this.getNameByCode(this.checkItems, params.value)
          },
          tooltipValueGetter: () => ''
        }, {
          headerName: this.$t('SystemMaintenance.Operation'),
          field: 'operator',
          width: 100,
          cellRenderer: (params) => {
            return this.getNameByCode(CheckRuleConstants.ALL_OPERATOR, params.value)
          }
        }, {
          headerName: this.$t('SystemMaintenance.FilterValue'),
          field: 'checkValue',
          width: 200,
          cellRenderer: (params) => {
            if (params.data.checkItem === 'TRUST_JOB_STATE' || params.data.checkItem === 'RELATED_JOB_STATE') {
              return ColumnUtils.getJobStateCN(Number(params.value))
            } else if (params.data.checkItem === 'LOCAL_SERVICES') {
              const item = [...LOCAL_SERVICES_TYPE].find(p => p.code === params.value)
              return item ? item.chineseName : ''
            } else if (params.data.checkItem === 'FILE_UPLOADED') {
              return this.convertFileCategoryLabel(params.value)
            } else if (params.data.checkItem === 'LOGIC_AP_CHARGE_ACCOUNT_ID_NOT_UNIQUE') {
              return this.convertChargeItemLabel(params.value)
            } else if (params.data.checkItem === CheckRuleConstants.REQUIRE_USER_DEFINED_ROLE_ID1.code || params.data.checkItem === CheckRuleConstants.REQUIRE_USER_DEFINED_ROLE_ID2.code) {
              return this.convertUserIdsLabel(params.value)
            } else if (params.data.checkItem === CheckRuleConstants.LOGIC_CONSIGNATION_COMPANY_SCOPE.code || params.data.checkItem === CheckRuleConstants.LOGIC_RECEIVABLE_ACCOUNT_OBJECT_SCOPE.code) {
              return this.convertCmpIdsLabel(params.value)
            } else if (params.data.checkItem === CheckRuleConstants.LOGIC_APPLICATION_STATUS_FOR_RELEASE.code) {
              return ColumnUtils.getApplicationReleaseStatus(Number(params.value))
            } else if (params.data.checkItem === CheckRuleConstants.INTEGRATED_ORDER_TYPE.code) {
              return this.convertIntegratedTypeLabel(params.value)
            } else if (params.data.checkItem === CheckRuleConstants.BILLING_CHARGE_CONFIRM_STATE_CHECK.code) {
              if (params.value === 'yes') {
                return this.$t('SeaExport.yes')
              }
              return ''
            } else if (params.data.checkItem === CheckRuleConstants.LOGIC_INVOICE_NATURE.code) {
              return ColumnUtils.columnLabelFunc(InvoiceConstant.INVOICE_NATURE_LIST, Number(params.value))
            } else if (params.data.checkItem === CheckRuleConstants.LOGIC_INVOICE_TAX_NATURE_SAME.code) {
              return ColumnUtils.booleanLabelFunction(Number(params.value))
            } else {
              return params.value || ''
            }
          }
        }, {
          headerName: this.$t('SystemMaintenance.CustomDescription'),
          field: 'customDescription',
          width: 200
        }, {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remark',
          width: 200
        }]
    },
    fileTypeEditorLob() {
      if (this.fileTypeEditor.lob.startsWith('FBA_')) {
        return this.fileTypeEditor.lob.substring(4)
      }
      return this.fileTypeEditor.lob
    },
    isSensitiveWord() {
      return this.oneCheckExpression.checkItem === this.LOGIC_SENSITIVE_WORD_ENGLISH_NAME.code || this.oneCheckExpression.checkItem === this.LOGIC_SENSITIVE_WORD_CHINESE_NAME.code || this.oneCheckExpression.checkItem === this.LOGIC_SENSITIVE_WORD_MARK.code ||
      this.oneCheckExpression.checkItem === this.LOGIC_SENSITIVE_WORD_COMMUNICATION_FIRST_LINE.code || this.oneCheckExpression.checkItem === this.LOGIC_SENSITIVE_WORD_HBL_COMMUNICATION_FIRST_LINE.code || this.oneCheckExpression.checkItem === this.LOGIC_SENSITIVE_WORD_JOB_COMMUNICATION_FIRST_LINE.code
    },
    showLikeOperator() {
      return this.isSensitiveWord ||
        this.oneCheckExpression.checkItem === CheckRuleConstants.LOGIC_CRM_CUSTOMER_CHINESE_NAME.code || this.oneCheckExpression.checkItem === CheckRuleConstants.LOGIC_CRM_CUSTOMER_ENGLISH_NAME.code
    },
    showNotLikeOperator() {
      return this.isSensitiveWord
    },
    showNotEmptyOperator() {
      return [CheckRuleConstants.REQUIRE_USER_DEFINED_ROLE_ID1.code,
        CheckRuleConstants.REQUIRE_USER_DEFINED_ROLE_ID2.code,
        CheckRuleConstants.BILL_TAX_ACCOUNT.code,
        CheckRuleConstants.BILL_COMPANY_EMAIL.code
      ].includes(this.oneCheckExpression.checkItem)
    },
    // 某些项目不展示通用操作符号（》=《）
    noCommonOperator() {
      return this.oneCheckExpression.checkItem === this.BILL_TAX_ACCOUNT.code || this.oneCheckExpression.checkItem === this.BILL_COMPANY_EMAIL.code
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    isEditCheckRule(val) {
      if (val) {
        this.categoryTypeChange(this.checkRule.checkCategory)
      } else {
        this.currOptStatus = this.optStatusDef.normal
        this.oneCheckExpression = { ...this.initOneCheckExpression() }
      }
    },
    'checkRule.checkCategory'(val) {
      this.categoryTypeChange(val)
    },
    'checkRule.checkNode'(newVal, oldVal) {
      if (oldVal === CheckRuleConstants.NODE_SAVE_USER.code || newVal === CheckRuleConstants.NODE_SAVE_USER.code) {
        const currStatus = CheckRuleConstants.CATEGORY_TYPE_MAPPING[this.checkRule.checkCategory]
        if (currStatus === 'require') {
          if (this.checkRule.checkNode === CheckRuleConstants.NODE_SAVE_USER.code) {
            this.checkItems = Array.from(CheckRuleConstants.USER_REQUIRES)
          } else {
            this.checkItems = Array.from(CheckRuleConstants.REQUIRES)
          }
        }
      }
      // CARGO-47750 NODE_BILL_AR_SURE 节点就排除掉 BILL_TAX_ACCOUNT、 BILL_COMPANY_EMAIL
      const currStatus = CheckRuleConstants.CATEGORY_TYPE_MAPPING[this.checkRule.checkCategory]
      if (currStatus === 'require') {
        if (newVal === CheckRuleConstants.NODE_BILL_AR_SURE.code) {
          // 不存在就添加
          if (!this.checkItems.includes(this.BILL_TAX_ACCOUNT)) {
            this.checkItems.push(this.BILL_TAX_ACCOUNT)
          }
          if (!this.checkItems.includes(this.BILL_COMPANY_EMAIL)) {
            this.checkItems.push(this.BILL_COMPANY_EMAIL)
          }
        } else {
          this.checkItems = this.checkItems.filter(item => item !== this.BILL_TAX_ACCOUNT && item !== this.BILL_COMPANY_EMAIL)
        }
      }
    },
    'checkRule.uuid'(val) {
      if (val) {
        this.initData()
      } else {
        this.initStatus()
        this.rowData = []
      }
    }
  },
  created() {
    this.gridOptions = {
      rowSelection: 'single',
      suppressCellSelection: true,
      defaultColDef: {
        resizable: true,
        filter: true
      },
      onRowClicked: this.onRowClick
    }
    getDocCategoryTypeTree().then(res => {
      res.data.forEach(item => {
        const pathArr = item.path.split(',')
        if (item.type === 2 && pathArr.length > 1) {
          this.docTypeMap.set(item.code.toUpperCase(), item.chineseName)
          this.docTypeReverseMap.set(item.chineseName, item.code.toUpperCase())
        }
      })
    })
    sensitiveWordApi.queryAll().then(res => {
      this.sensitiveWordChinesSet.add('ALL')
      this.sensitiveWordEnglishSet.add('ALL')
      this.sensitiveWordMarkSet.add('ALL')
      this.sensitiveWordCommunicationSet.add('ALL')
      for (const item of res.data) {
        switch (item.wordField) {
          case 0:
            this.sensitiveWordChinesSet.add(item.words)
            break
          case 1:
            this.sensitiveWordEnglishSet.add(item.words)
            break
          case 2:
            this.sensitiveWordMarkSet.add(item.words)
            break
          case 3:
            this.sensitiveWordCommunicationSet.add(item.words)
            break
        }
      }
    })
  },
  mounted() {
    // this.initData()
  },
  methods: {
    categoryTypeChange(val) {
      const currStatus = CheckRuleConstants.CATEGORY_TYPE_MAPPING[val]
      this.operators = CheckRuleConstants.OPERATORS
      this.oneCheckExpression.checkValue = ''
      switch (currStatus) {
        case 'require':
          if (this.checkRule.checkNode === CheckRuleConstants.NODE_SAVE_USER.code) {
            this.checkItems = Array.from(CheckRuleConstants.USER_REQUIRES)
          } else {
            this.initCheckItemWithRequire()
          }
          this.operators = [CheckRuleConstants.NOT_EQUAL, CheckRuleConstants.GREATER_THAN, CheckRuleConstants.EQUAL]
          this.oneCheckExpression.checkValue = '空'
          break
        case 'profit':
          this.checkItems = Array.from(CheckRuleConstants.PROFITS)
          break
        case 'logic':
          this.checkItems = Array.from(CheckRuleConstants.LOGICS)
          this.operators = CheckRuleConstants.LIKE_OPERATOR
          break
        case 'changed':
          this.checkItems = Array.from(CheckRuleConstants.DATA_CHANGES)
          break
        default:
          this.checkItems = []
      }
    },
    // 将验证类型为REQUIRES时的checkItems的填充方法进行抽离，避免后续修改点过多
    initCheckItemWithRequire() {
      this.checkItems = Array.from(CheckRuleConstants.REQUIRES)
    },
    getNameByCode,
    initStatus() {
      this.currOptStatus = this.optStatusDef.normal
      this.oneCheckExpression = { ...this.initOneCheckExpression() }
    },
    initData() {
      this.initStatus()
      this.fetchDataList()
    },
    onRowClick(event) {
      this.oneCheckExpression = { ...event.data }
    },
    /**
     * 获取 详情
     * @param forceRequest 强制发送请求获取数据
     * @returns {Promise<void>}
     */
    async getCheckExpressionDetail(forceRequest = false) {
      this.loading = getLoading()
      await getCheckExpressionByUuid(this.oneCheckExpression.uuid).then(res => {
        this.oneCheckExpression = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    async fetchDataList() {
      this.loading = getLoading()
      await getCheckExpressionList({ checkRuleUuid: this.checkRule.uuid }).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    async showAdd() {
      this.oneCheckExpression = { ...this.initOneCheckExpression() }
      // 添加临时唯一标识 用于后面修改显示
      this.oneCheckExpression.uuid = 'addExpression_' + getUuid()
      this.currOptStatus = this.optStatusDef.edit
    },
    async showEdit() {
      const row = this.getGridSelected(this.gridOptions)
      if (!row) {
        return
      }
      Object.assign(this.oneCheckExpression, row)
      if (this.oneCheckExpression.checkItem === this.LOGIC_INVOICE_NATURE.code) {
        this.oneCheckExpression.checkValue = Number(this.oneCheckExpression.checkValue)
      }
      this.currOptStatus = this.optStatusDef.edit
    },
    async del() {
      if (!this.getGridSelected(this.gridOptions)) {
        return
      }
      await this.$confirm(this.$t('SystemMaintenance.AreToDeleteTheRecord'), this.$t('SystemMaintenance.Prompt'), { type: 'waring' })
      this.loading = getLoading()
      delCheckExpression(this.oneCheckExpression.uuid).then(async res => {
        this.$message.success(this.$t('SystemMaintenance.DeleteSuccess'))
        this.rowData = this.rowData.filter(item => item.uuid !== this.oneCheckExpression.uuid)
        this.oneCheckExpression = { ...this.initOneCheckExpression() }
        this.currOptStatus = this.optStatusDef.normal
      }).finally(() => {
        this.loading.close()
      })
    },
    async cancel() {
      this.initStatus()
    },
    async checkForm() {
      const { checkItem, operator, checkValue } = this.oneCheckExpression
      await Assert.isNotBlank(checkItem, this.$t('SystemMaintenance.PleaseSelectValidationItem'))
      console.log(checkItem)
      // CARGO-46883 限制自定义岗位1，2 操作符号为不为空 就不需要校验过滤值
      if (this.showNotEmptyOperator && operator === this.NOT_EMPTY.code) {
        return
      }
      if (!['MBL_CANNOT_REPEATED', CheckRuleConstants.HBL_MERGES_KEEP_UP_WITH_WEIGHT.code, CheckRuleConstants.HBL_SPLITS_KEEP_UP_WITH_WEIGHT.code].includes(checkItem)) {
        await Assert.isNotBlank(checkValue, this.$t('SystemMaintenance.PleaseSelectTheFilterValue'))
      }
    },
    async save() {
      await this.checkForm()
      // this.oneCheckExpression.checkRuleUuid = this.checkRule.uuid
      // this.loading = getLoading()
      // saveCheckExpression(this.oneCheckExpression, this.oneCheckExpression.uuid).then(async res => {
      this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
      this.rowData = this.rowData.filter(item => item.uuid !== this.oneCheckExpression.uuid)
      this.rowData.push({ ...this.oneCheckExpression })
      this.initStatus()
    },
    getGridSelected(gridOptions) {
      const cell = gridOptions.api.getFocusedCell()
      const nodes = gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      if (!node || !node.data) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectDataFirst'))
        return null
      }
      return node.data
    },
    initOneCheckExpression() {
      return {
        uuid: '',
        relation: 0,
        checkItem: '',
        checkRuleUuid: '',
        checkValue: '',
        operator: ''
      }
    },
    onSelectFileType() {
      if (!this.isEdit) {
        return
      }
      if (this.oneCheckExpression.checkItem === 'FILE_UPLOADED') {
        this.fileTypeEditor.fileCategory = this.oneCheckExpression.checkValue
      } else if (this.oneCheckExpression.checkItem === this.LOGIC_DYNAMIC_FILE_TYPE.code || this.oneCheckExpression.checkItem === this.IS_ATTACHMENT_MISSING.code) {
        if (this.oneCheckExpression.checkValue) {
          this.fileTypeEditor.fileCategory = Array.from(this.oneCheckExpression.checkValue.split(','), p => this.docTypeReverseMap.get(p) || '').join(',')
        } else {
          this.fileTypeEditor.fileCategory = ''
        }
      }
      this.fileTypeEditor.visible = true
    },
    onSaveFileType(data) {
      if (this.oneCheckExpression.checkItem === 'FILE_UPLOADED') {
        this.oneCheckExpression.checkValue = data.fileCategory
      } else if (this.oneCheckExpression.checkItem === this.LOGIC_DYNAMIC_FILE_TYPE.code || this.oneCheckExpression.checkItem === this.IS_ATTACHMENT_MISSING.code) {
        this.oneCheckExpression.checkValue = data.fileCategoryLabel
      }
    },
    convertFileCategoryLabel(categories) {
      if (categories) {
        return Array.from(categories.split(','), p => this.docTypeMap.get(p.toUpperCase()) || p).join(',')
      }
      return ''
    },
    onCheckItemChange() {
      if (this.oneCheckExpression.checkItem === 'SLAVE_FILE_VERIFY') {
        this.oneCheckExpression.checkValue = this.$t('SystemMaintenance.BillOfLading')
      } else if (this.oneCheckExpression.checkItem === this.LOGIC_MANIFEST_EQUAL_CONTAINER_NUM.code) {
        this.oneCheckExpression.operator = CheckRuleConstants.EQUAL.code
        this.oneCheckExpression.checkValue = this.$t('SystemMaintenance.Empty')
      } else if (this.oneCheckExpression.checkItem === this.LOGIC_QUANTITY_WEIGHT_VOLUME_CONSISTENT.code) {
        this.oneCheckExpression.operator = CheckRuleConstants.EQUAL.code
        this.oneCheckExpression.checkValue = this.$t('CargoMsg.Cargo_None')
      } else if (this.oneCheckExpression.checkItem === this.REQUIRE_CUSTOMER_LEVEL.code ||
        this.oneCheckExpression.checkItem === CheckRuleConstants.REQUIRE_TRANSPORT_SOURCE.code ||
        this.oneCheckExpression.checkItem === CheckRuleConstants.REQUIRE_CUSTOMER_EXPAND_MODE.code) {
        this.oneCheckExpression.operator = CheckRuleConstants.NOT_EQUAL.code
        this.oneCheckExpression.checkValue = this.$t('SystemMaintenance.Empty')
      } else if (this.oneCheckExpression.checkItem === this.REQUIRE_USER_DEFINED_ROLE_ID1.code || this.oneCheckExpression.checkItem === this.REQUIRE_USER_DEFINED_ROLE_ID2.code) {
        this.oneCheckExpression.operator = CheckRuleConstants.EQUAL.code
        this.oneCheckExpression.checkValue = ''
      } else if (this.oneCheckExpression.checkItem === this.LOGIC_CONSIGNATION_COMPANY_SCOPE.code || this.oneCheckExpression.checkItem === this.LOGIC_RECEIVABLE_ACCOUNT_OBJECT_SCOPE.code) {
        this.oneCheckExpression.operator = CheckRuleConstants.EQUAL.code
        this.oneCheckExpression.checkValue = ''
      } else if (this.oneCheckExpression.checkItem === this.SECONDARY_SERVICE_TYPE_REQUIRE.code) {
        this.oneCheckExpression.operator = CheckRuleConstants.EQUAL.code
        this.oneCheckExpression.checkValue = ''
      } else if (this.oneCheckExpression.checkItem === this.REQUIRE_CHECKED_HBL.code) {
        this.oneCheckExpression.operator = CheckRuleConstants.EQUAL.code
        this.oneCheckExpression.checkValue = ''
      } else if (this.oneCheckExpression.checkItem === this.LOGIC_AR_ACCOUNT_CUSTOMER_CODE.code) {
        this.oneCheckExpression.operator = CheckRuleConstants.EQUAL.code
        this.oneCheckExpression.checkValue = this.$t('SystemMaintenance.Yes')
      } else if ([CheckRuleConstants.LOGIC_TRADE_DETAIL_ENGLISH_NAME.code, CheckRuleConstants.LOGIC_TRADE_DETAIL_PACK.code,
        CheckRuleConstants.LOGIC_TRADE_DETAIL_PACK_NAME.code, CheckRuleConstants.LOGIC_TRADE_DETAIL_HSCODE.code,
        CheckRuleConstants.LOGIC_TRADE_DETAIL_MARK.code, CheckRuleConstants.LOGIC_CHEMICAL_PRODUCT_CUS_CODE.code
      ].includes(this.oneCheckExpression.checkItem)) {
        this.oneCheckExpression.operator = CheckRuleConstants.NOT_EQUAL.code
        this.oneCheckExpression.checkValue = this.$t('SystemMaintenance.Empty')
      } else if ([CheckRuleConstants.REQUIRE_CREDIT_PAYMENT_PERIOD.code, CheckRuleConstants.REQUIRE_CREDIT_ADDITIONAL_DESCRIPTION.code,
        CheckRuleConstants.REQUIRE_CONTACT_PERSON.code, CheckRuleConstants.REQUIRE_INVOICE_PAYEE.code,
        CheckRuleConstants.REQUIRE_INVOICE_PAYEE_BANK.code].includes(this.oneCheckExpression.checkItem)) {
        this.oneCheckExpression.operator = CheckRuleConstants.NOT_EQUAL.code
        this.oneCheckExpression.checkValue = this.$t('SystemMaintenance.Empty')
      }
    },
    filterCheckItems(checkNode, checkItemCode) {
      if (checkNode === CheckRuleConstants.NODE_SAVE_PARTNER.code || checkNode === CheckRuleConstants.NODE_COMMIT_PARTNER.code) {
        return [CheckRuleConstants.REQUIRE_CUSTOMER_LEVEL.code, CheckRuleConstants.REQUIRE_CUSTOMER_SOURCE.code, CheckRuleConstants.REQUIRE_CREDIT_PAYMENT_PERIOD.code,
          CheckRuleConstants.REQUIRE_CREDIT_ADDITIONAL_DESCRIPTION.code, CheckRuleConstants.REQUIRE_CONTACT_PERSON.code, CheckRuleConstants.REQUIRE_INVOICE_PAYEE.code,
          CheckRuleConstants.REQUIRE_INVOICE_PAYEE_BANK.code, CheckRuleConstants.INVOICE_NOT_EMPTY.code, CheckRuleConstants.INVOICE_HEADER_BANK_NOT_EMPTY.code,
          CheckRuleConstants.INVOICE_HEADER_NOT_DUPLICATED.code, CheckRuleConstants.CONTACT_PHONE.code, CheckRuleConstants.INVOICE_IDENTIFICATION_NUMBER.code, CheckRuleConstants.IS_ATTACHMENT_MISSING.code,
          CheckRuleConstants.INFORMATION_INVOICE_TITLE.code, CheckRuleConstants.INVOICE_HEADER_BANK_NOT_EMPTY.code, CheckRuleConstants.LOGIC_UNIQUE_BUSINESS_REFERENCE_NUMBER.code].includes(checkItemCode)
      } else if (checkNode === CheckRuleConstants.NODE_CRM_CUSTOMER_INPUT_SAVE.code) {
        return checkItemCode === CheckRuleConstants.LOGIC_CRM_CUSTOMER_CHINESE_NAME.code || checkItemCode === CheckRuleConstants.LOGIC_CRM_CUSTOMER_ENGLISH_NAME.code
      }
      return true
    },
    filterOperators(checkItem, operatorCode) {
      if (checkItem === CheckRuleConstants.LOGIC_CRM_CUSTOMER_CHINESE_NAME.code || checkItem === CheckRuleConstants.LOGIC_CRM_CUSTOMER_ENGLISH_NAME.code || checkItem === CheckRuleConstants.LOGIC_CHARGE_INVOICE_REVIEW_STATE.code) {
        return operatorCode === CheckRuleConstants.EQUAL.code
      } else if ([CheckRuleConstants.REQUIRE_CUSTOMER_LEVEL.code, CheckRuleConstants.REQUIRE_CUSTOMER_SOURCE.code, CheckRuleConstants.REQUIRE_CREDIT_PAYMENT_PERIOD.code,
        CheckRuleConstants.REQUIRE_CREDIT_ADDITIONAL_DESCRIPTION.code, CheckRuleConstants.REQUIRE_CONTACT_PERSON.code, CheckRuleConstants.REQUIRE_INVOICE_PAYEE.code,
        CheckRuleConstants.REQUIRE_INVOICE_PAYEE_BANK.code, CheckRuleConstants.REQUIRE_TRANSPORT_SOURCE.code, CheckRuleConstants.REQUIRE_CUSTOMER_EXPAND_MODE.code,
        CheckRuleConstants.INVOICE_NOT_EMPTY.code, CheckRuleConstants.CONTACT_PHONE.code, CheckRuleConstants.INFORMATION_INVOICE_TITLE.code, CheckRuleConstants.INVOICE_IDENTIFICATION_NUMBER.code,
        CheckRuleConstants.INVOICE_HEADER_BANK_NOT_EMPTY.code, CheckRuleConstants.INVOICE_HEADER_NOT_DUPLICATED.code, CheckRuleConstants.LOGIC_UNIQUE_BUSINESS_REFERENCE_NUMBER.code].includes(checkItem)) {
        return operatorCode === CheckRuleConstants.NOT_EQUAL.code
      } else if ([this.REQUIRE_USER_DEFINED_ROLE_ID1.code, this.REQUIRE_USER_DEFINED_ROLE_ID2.code, CheckRuleConstants.CONTAINER_WITH_CONTAINERNO_NEED_QWC.code, CheckRuleConstants.COUNTER_PARTY_BILLING_NO.code].includes(checkItem)) {
        return operatorCode === CheckRuleConstants.EQUAL.code || operatorCode === CheckRuleConstants.NOT_EQUAL.code
      } else if (this.isSensitiveWord || this.noCommonOperator) {
        return false
      } else if ([CheckRuleConstants.NUMBER_PACKING_INFORMATION_PIECES.code, CheckRuleConstants.PACKING_INFORMATION_GROSS_WEIGHT.code, CheckRuleConstants.PACKING_INFORMATION_VOLUME.code].includes(checkItem)) {
        return operatorCode !== CheckRuleConstants.GREATER_THAN.code
      } else if ([this.REQUIRE_USER_DEFINED_ROLE_ID1.code, this.REQUIRE_USER_DEFINED_ROLE_ID1.code].includes(checkItem)) {
        return operatorCode === CheckRuleConstants.EQUAL.code
      } else if ([this.LOGIC_CONSIGNATION_COMPANY_SCOPE.code, this.LOGIC_RECEIVABLE_ACCOUNT_OBJECT_SCOPE.code, this.CLIENT_SCOPE_HAVE_CHARGE.code, this.LOGIC_INVOICE_NATURE.code].includes(checkItem)) {
        return operatorCode === CheckRuleConstants.EQUAL.code || operatorCode === CheckRuleConstants.NOT_EQUAL.code
      } else if ([this.SECONDARY_SERVICE_TYPE_REQUIRE.code, this.LOGIC_INVOICE_TAX_NATURE_SAME.code].includes(checkItem)) {
        return operatorCode === CheckRuleConstants.EQUAL.code
      } else if ([this.REQUIRE_AR_CHARGE_RATE.code, this.REQUIRE_AP_CHARGE_RATE.code].includes(checkItem)) {
        return operatorCode === CheckRuleConstants.EQUAL.code || operatorCode === CheckRuleConstants.NOT_EQUAL.code || operatorCode === CheckRuleConstants.LIKE.code || operatorCode === CheckRuleConstants.NOT_LIKE.code
      } else if ([CheckRuleConstants.LOGIC_TRADE_DETAIL_ENGLISH_NAME.code, CheckRuleConstants.LOGIC_TRADE_DETAIL_PACK.code,
        CheckRuleConstants.LOGIC_TRADE_DETAIL_PACK_NAME.code, CheckRuleConstants.LOGIC_TRADE_DETAIL_HSCODE.code,
        CheckRuleConstants.LOGIC_TRADE_DETAIL_MARK.code, CheckRuleConstants.LOGIC_CHEMICAL_PRODUCT_CUS_CODE.code
      ].includes(this.oneCheckExpression.checkItem)) {
        return operatorCode === CheckRuleConstants.NOT_EQUAL.code
      }
      return true
    },
    convertChargeItemLabel(categories) {
      if (categories) {
        // 反显列表数据
        const itemIds = categories instanceof Array ? categories : JSON.parse(categories || '[]')
        const arr = itemIds.map((val) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', val, 'enName')
        })
        return arr.join()
      }
      return ''
    },
    convertUserIdsLabel(userIds) {
      if (userIds) {
        return Array.from(userIds.split(','), p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(p), 'chineseName')).join(',')
      }
      return ''
    },
    convertCmpIdsLabel(cmpIds) {
      if (cmpIds) {
        return Array.from(cmpIds.split(','), p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(p), 'chineseName')).join(',')
      }
      return ''
    },
    toArray(val) {
      if (val) {
        if (val instanceof Array) {
          return val
        }
        return JSON.parse(val)
      } else {
        return []
      }
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(arr) {
      if (arr && arr.length > 0) {
        return arr.join(',')
      }
      return ''
    },
    operateChangeHandle(option) {
      if (option === this.NOT_EMPTY.code) {
        this.oneCheckExpression.checkValue = ''
      } else if (option === CheckRuleConstants.EQUAL.code && this.oneCheckExpression.checkItem === CheckRuleConstants.IS_ATTACHMENT_MISSING.code) {
        this.fileTypeEditor.lob = 'PT'
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .check-expression .box-card>>>.el-card__header{
    padding:8px 20px!important;
    div{
      display: flex;
      justify-content: space-between;
    }
  }
  .check-expression .box-card>>>.el-card__body{
    height:calc(50% - 35px)!important;
  }
</style>
